export const EFFECT_TYPES = {
  STUN: 'stun',
  ROOT: 'root',
  SILENCE: 'silence',
  SLOW: 'slow',
  KNOCKUP: 'knockup',
  INVULNERABLE: 'invulnerable'
};

export class StatusEffectManager {
  constructor() {
    this.effects = [];
  }

  addEffect(type, duration, value = 0, sourceId = null) {
    // Refresh existing effect if stronger/longer or stack
    const existing = this.effects.find(e => e.type === type);
    if (existing) {
      existing.duration = Math.max(existing.duration, duration);
      existing.value = Math.max(existing.value, value);
    } else {
      this.effects.push({ type, duration, value, sourceId, elapsed: 0 });
    }
  }

  update(dt) {
    for (let i = this.effects.length - 1; i >= 0; i--) {
      this.effects[i].duration -= dt;
      this.effects[i].elapsed += dt;
      if (this.effects[i].duration <= 0) {
        this.effects.splice(i, 1);
      }
    }
  }

  hasEffect(type) {
    return this.effects.some(e => e.type === type);
  }

  canMove() {
    return !this.hasEffect(EFFECT_TYPES.STUN) && 
           !this.hasEffect(EFFECT_TYPES.ROOT) && 
           !this.hasEffect(EFFECT_TYPES.KNOCKUP);
  }

  canAttack() {
    return !this.hasEffect(EFFECT_TYPES.STUN) && 
           !this.hasEffect(EFFECT_TYPES.KNOCKUP);
  }

  canCastSkills() {
    return !this.hasEffect(EFFECT_TYPES.STUN) && 
           !this.hasEffect(EFFECT_TYPES.SILENCE) && 
           !this.hasEffect(EFFECT_TYPES.KNOCKUP);
  }

  getSlowMultiplier() {
    const slows = this.effects.filter(e => e.type === EFFECT_TYPES.SLOW);
    if (slows.length === 0) return 1.0;
    const maxSlow = Math.max(...slows.map(s => s.value));
    return Math.max(0.1, 1.0 - maxSlow);
  }
}
